import columns from '../../../../../images/column_row/columns.svg';
import sortAscNames from '../../../../../images/column_row/measure-name_sort-ascending.svg';
import sortDescNames from '../../../../../images/column_row/measure-name_sort-descending.svg';
import sortAscDiscrete from '../../../../../images/column_row/pill_sort-ascending.svg';
import sortDescDiscrete from '../../../../../images/column_row/pill_sort-descending.svg';
import rows from '../../../../../images/column_row/rows.svg';
import sortAscContinuous from '../../../../../images/column_row/sort-ascending-continuous.svg';
import sortDescContinuous from '../../../../../images/column_row/sort-descending-continuous.svg';
import booleanGrayIcon from '../../../../../images/field_list/boolean.svg';
import booleanIcon from '../../../../../images/field_list/boolean-blue.svg';
import continuousDate from '../../../../../images/field_list/continuous-date.svg';
import continuousNumber from '../../../../../images/field_list/continuous-number.svg';
import discreteDate from '../../../../../images/field_list/discrete-date.svg';
import discreteNumber from '../../../../../images/field_list/discrete-number.svg';
import discreteText from '../../../../../images/field_list/discrete-text.svg';
import fail from '../../../../../images/field_list/fail.svg';
import markAngle from '../../../../../images/marks/mark-angle.svg';
import markColor from '../../../../../images/marks/mark-color.svg';
import markDetail from '../../../../../images/marks/mark-detail.svg';
import markLabel from '../../../../../images/marks/mark-label.svg';
import markSize from '../../../../../images/marks/mark-size.svg';
import markTooltip from '../../../../../images/marks/mark-tooltip.svg';
import backDisabled from '../../../../../images/toolbar/back_disabled.svg';
import backEnabled from '../../../../../images/toolbar/back_enabled.svg';
import clearSelected from '../../../../../images/toolbar/clear_selected.svg';
import clear from '../../../../../images/toolbar/clear.svg';
import duplicate from '../../../../../images/toolbar/duplicate.svg';
import forwardDisabled from '../../../../../images/toolbar/forward_disabled.svg';
import forwardEnabled from '../../../../../images/toolbar/forward_enabled.svg';
import home from '../../../../../images/toolbar/home.svg';
import newVisualization from '../../../../../images/toolbar/new-visualization.svg';
import sortAscending from '../../../../../images/toolbar/sort-ascending.svg';
import sortDescending from '../../../../../images/toolbar/sort-descending.svg';
import swap from '../../../../../images/toolbar/swap.svg';
import toolbarDropdownSelected from '../../../../../images/toolbar/toolbar-dropdown-selected.svg';
import toolbarDropdown from '../../../../../images/toolbar/toolbar-dropdown.svg';

export const ToolbarIcons = {
  swap,
  backEnabled,
  backDisabled,
  clear,
  clearSelected,
  duplicate,
  forwardDisabled,
  forwardEnabled,
  home,
  newVisualization,
  sortAscending,
  sortDescending,
  toolbarDropdown,
  toolbarDropdownSelected,
};

export const MarksIcons = {
  color: markColor,
  detail: markDetail,
  label: markLabel,
  size: markSize,
  tooltip: markTooltip,
  angle: markAngle,
};

export const FieldIcons = {
  booleanIcon,
  continuousDate,
  continuousNumber,
  discreteDate,
  discreteNumber,
  discreteText,
  fail,
};

export const ColumnRow = {
  sortAscContinuous,
  sortDescContinuous,
  sortAscDiscrete,
  sortDescDiscrete,
  sortAscNames,
  sortDescNames,
  columns,
  rows,
};
